import React from 'react';

/**
 * Conditionally wraps `children` with `wrap` (a function returning an element)
 * when `if` is true; otherwise renders `children` as-is. Useful for optionally
 * wrapping something in a link/container without branching the whole JSX tree.
 */
function Wrap({ if: condition, wrapper, children }) {
    return condition ? wrapper(children) : children;
}

export default Wrap;
